import { render, staticRenderFns } from "./data17.vue?vue&type=template&id=42c67f5e&scoped=true&"
import script from "./data17.vue?vue&type=script&lang=js&"
export * from "./data17.vue?vue&type=script&lang=js&"
import style1 from "./data17.vue?vue&type=style&index=1&id=42c67f5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c67f5e",
  null
  
)

export default component.exports